import React, { useState, useEffect } from 'react';

import CSSNumberValueControl from 'generics/components/css-number-value-control';

import './index.scss';

function ColumnSpacingInput(props) {

  const [columnSpacing, setColumnSpacing] = useState(props.value);

  useEffect(function onValueChange() {

    setColumnSpacing(props.value);

  }, [props.value]);

  function handleColumnSpacingInputChange(value) {

    if (!value) {
      return;
    }

    setColumnSpacing(value);

    const _columnSpacing = +(value.replace('px', ''));

    if (isNaN(_columnSpacing)) {
      return;
    }

    if (_columnSpacing === 0 || _columnSpacing < 5) {
      return;
    }

    props.onChange(_columnSpacing);

  }

  function renderMain() {

    const valueControlProperties = {
      value: columnSpacing,
      onChange(value) {
        handleColumnSpacingInputChange(value);
      }
    };

    return <CSSNumberValueControl {...valueControlProperties} />;
  }

  return renderMain();
}

export default ColumnSpacingInput;